import { Component, OnInit, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { SliderModule } from 'primeng/slider';
import { AccessibilityPageComponent } from './accessibility-page/accessibility-page.component';
import { SecurityAndPrivacyPageComponent } from "./security-and-privacy-page/security-and-privacy-page.component";
import { DataService } from 'src/app/service/data.service';
import { InputTextModule } from 'primeng/inputtext';
import { BadgeDisplayComponent } from './badge-display/badge-display.component';
import { PlatformUser } from 'src/app/api/db/entities/PlatformUser';
import { ProgressService } from 'src/app/service/progress.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-profile-page',
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule,
    SliderModule,
    AccessibilityPageComponent,
    SecurityAndPrivacyPageComponent,
    InputTextModule,
    BadgeDisplayComponent,
    FormsModule
],
  templateUrl: './profile-page.component.html',
  styleUrl: './profile-page.component.scss'
})
export class ProfilePageComponent implements OnInit {

  protected platformUser: PlatformUser = this.dataService.user();

  protected bioVisible: boolean = false;
  protected accessibilityVisible: boolean = false;
  protected securitySettingsVisible: boolean = false;
  protected communicationSettingsVisible: boolean = false;
  protected bioText: string | null;
  protected screenName: string | null;

  protected isEditing: boolean = false;

  




  constructor(protected dataService: DataService, protected progressService: ProgressService)
  {
  
  }

  ngOnInit(): void {
    this.viewBio();
  }





  clearVisibility() {
    this.bioVisible = false;
    this.accessibilityVisible = false;
    this.securitySettingsVisible = false;
    this.communicationSettingsVisible = false;
  }

  viewBio () {
    this.clearVisibility();
    this.bioVisible = true;
  }

  viewAccessibility () {
    this.clearVisibility();
    this.accessibilityVisible = true;
  }

  viewSecuritySettings () {
    this.clearVisibility();
    this.securitySettingsVisible = true;
  }

  viewCommunicationSettings () {
    this.clearVisibility();
    this.communicationSettingsVisible = true;
  }
  
  editBio() {
    this.isEditing = true;
  }

  async saveBio() {
    this.progressService.blockWithMessage("Updating Bio");
    this.isEditing = false;
    console.log(this.platformUser.bioText);

   const output = await this.dataService.saveUserBio(this.platformUser);

    if(output === "DONE") {
      console.log("Successfully Updated Bio");
    }
    
    console.log("this is the local variable check:", this.platformUser);

    this.progressService.unBlock();
  }
  

}
